var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 80,
    viewBox: "0 0 116 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.3183 32.342C75.0547 32.5446 70.4008 35.1413 70.4008 40.9154C70.4008 47.5941 76.3228 49.9568 76.5 50.0153C76.4727 50.1593 75.5592 53.2511 73.3777 56.4014C71.4324 59.1737 69.4009 61.9415 66.3103 61.9415C63.2198 61.9415 62.4245 60.1638 58.8567 60.1638C55.3799 60.1638 54.1437 62 51.3167 62C48.4898 62 46.5173 59.4347 44.2494 56.2844C41.6225 52.5851 39.5 46.838 39.5 41.3834C39.5 32.6346 45.2447 27.9946 50.8986 27.9946C53.9028 27.9946 56.407 29.9478 58.2931 29.9478C60.0884 29.9478 62.888 27.8776 66.3058 27.8776C67.6011 27.8776 72.2551 27.9946 75.3183 32.342ZM64.6833 24.1737C66.0967 22.5131 67.0966 20.2088 67.0966 17.9046C67.0966 17.5851 67.0693 17.261 67.0103 17C64.7105 17.0855 61.9745 18.5167 60.3247 20.4113C59.0294 21.8695 57.8205 24.1737 57.8205 26.5095C57.8205 26.8605 57.8796 27.2115 57.9068 27.324C58.0523 27.351 58.2886 27.3825 58.5249 27.3825C60.5883 27.3825 63.1835 26.0144 64.6833 24.1737Z",
    fill: "#1E2532"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.a86a89f00dfccbe6131519357e887f98.svg";
export { ForwardRef as ReactComponent };